<template lang="html">
	<div class="button_multiple">
		<div>
			<el-button type="primary" size="mini" icon="el-icon-search" v-if="hasBtn('sys:'+model+':add')" @click="$emit('click_add')">添加</el-button>
			<el-button type="danger" size="mini" icon="el-icon-delete" v-if="hasBtn('sys:'+model+':dall')" @click="$emit('click_dall')">删除</el-button>
			<el-button type="" size="mini" icon="el-icon-upload2" v-if="hasBtn('sys:'+model+':import')" @click="$emit('click_import')">导入</el-button>
			<el-button type="success" size="mini" icon="el-icon-download" v-if="hasBtn('sys:'+model+':export')" @click="$emit('click_export')">导出</el-button>
			<el-button type="" size="mini" v-if="hasBtn('sys:'+model+':expand')" @click="$emit('click_toggle_all',true)">展开全部</el-button>
			<el-button type="" size="mini" v-if="hasBtn('sys:'+model+':collapse')" @click="$emit('click_toggle_all',false)">折叠全部</el-button>
		</div>
		<div>
			<el-button type="" size="mini" icon="el-icon-refresh" @click="$emit('click_init')"></el-button>
			<el-button type="" size="mini" icon="el-icon-full-screen" @click="$emit('click_full')"></el-button>
		</div>
	</div>
</template>
<script>
export default {
	name: 'buttonCollection',
	data() {
		return {}
	},
	props: {
	    model: {
			type: String,
			default: ''
	    }
	},
	methods: {
	}
}
</script>
<style lang="css">

</style>



// WEBPACK FOOTER //
// src/components/buttonCollection.vue